import {BaseService} from "./BaseService";

export class ConversationTypeService extends BaseService<any, any> {

	protected modelUrl(): string {
		return "conversation-type";
	}

}